import '.j8{max-height:254px;}.ssr-plugin'
import '.ck{overflow:auto;}.ssr-plugin'
import '.j9{padding:8px 8px 8px 8px;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'

type DropZoneProps = {
  setDraggingOver: (draggingOver: boolean) => void
  fileUploadHandler: (files: File[]) => void
  errorMessage: string | null
  children: React.ReactNode
  style?: Style
  onChange?: (
    file: File | void,
    updateProgress: (p: number) => void,
    url: string | void,
  ) => void
}

export const DropZone = ({
  setDraggingOver,
  fileUploadHandler,
  errorMessage,
  children,
  style,
  onChange,
}: DropZoneProps) => {
  return (
    <styled.div className="j8 ck j9 s"
      onDragOver={(e) => {
        setDraggingOver(true)
        e.stopPropagation()
        e.preventDefault()
      }}
      onDragEnter={(e) => {
        setDraggingOver(true)
        e.stopPropagation()
        e.preventDefault()
      }}
      onMouseLeave={() => {
        setDraggingOver(false)
      }}
      onDragLeave={() => {
        setDraggingOver(false)
      }}
      onDrop={async (e) => {
        setDraggingOver(false)
        e.stopPropagation()
        e.preventDefault()
        const files = [...e.dataTransfer.files]
        const uploadedUrl = await fileUploadHandler(files)
        typeof onChange === 'function' && onChange(null, null, uploadedUrl)
      }}
      style={{
        borderRadius: radius[20],
        border: `1px solid ${errorMessage ? colors.red100 : colors.neutral20Adjusted}`,
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}
